import './style.scss';

function DeleteSchoolModal({ setDeleteModal, deleteGroup, school }) {
  return (
    <section className='main-deleteGroup-container'>
      <p className='title'>ELIMINAR GRUPO </p>
      <p className='description'>
        ¿Deseas eliminar el Grupo: ({school?.groupInfo.code}) de la escuela {school?.code}?
      </p>
      <div className='buttons-container'>
        <button className='blue-site-button' onClick={() => deleteGroup(school?.groupInfo.id, school?.id)}>ACEPTAR</button>
        <button
          className='button-white-border-blue'
          onClick={() => setDeleteModal()}>
          CANCELAR
        </button>
      </div>
    </section>
  );
}

export default DeleteSchoolModal;